import getTimezone from './getTimezone';
import {
  coordinateNumber,
  isValidCoordinates,
  isValidTimezone,
  sameTimezone,
} from './timezones';

export class SchoolTimezoneError extends Error {}

export const verifySchoolTimezone = async (school: {
  lat?: unknown;
  lng?: unknown;
  timezone?: unknown;
}) => {
  if (!isValidCoordinates(school.lat, school.lng)) {
    throw new SchoolTimezoneError(
      'Enter valid school coordinates before saving.',
    );
  }
  if (!isValidTimezone(school.timezone)) {
    throw new SchoolTimezoneError('Select a valid timezone before saving.');
  }
  let detected: string;
  try {
    detected = (
      await getTimezone(
        coordinateNumber(school.lat),
        coordinateNumber(school.lng),
      )
    ).id;
  } catch (error) {
    throw new SchoolTimezoneError(
      error instanceof Error
        ? error.message
        : 'Could not verify the school timezone.',
    );
  }
  if (!sameTimezone(school.timezone, detected)) {
    throw new SchoolTimezoneError(
      `This location uses ${detected}. Select that timezone or correct the school coordinates.`,
    );
  }
};
